<template>
  <div class="player-container">
    <video-player
      @ended="close"
      ref="videoPlayer"
      class="vjs-theme-dt"
      aspectRatio="16:9"
      :options="options"
      :playbackRates="config.playbackRates"
      v-model:playbackRate="config.playbackRate"
      autoplay="true"
      controls
    >
      <template v-slot>
        <div class="header">
          <button class="btn-close" @click="close"><icon-arrow-left /></button>
          <h3 class="title">{{ options.title }}</h3>
        </div>
      </template>
    </video-player>
  </div>
</template>

<script>
import { VideoPlayer } from "@videojs-player/vue";
import IconArrowLeft from "@/components/icons/iconArrowLeft.vue";

export default {
  components: { IconArrowLeft, VideoPlayer },
  props: {
    trailer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      config: {
        playbackRate: 1,
        playbackRates: [0.5, 0.75, 1, 1.5],
      },
    };
  },
  computed: {
    options() {
      return {
        aspectRatio: "16:9",
        title: this.trailer.title,
        sources: [
          {
            src: this.trailer.url,
            type: "application/x-mpegURL",
            poster: this.trailer.poster,
            title: this.trailer.title,
          },
        ],
        controlBar: true,
      };
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "video.js/dist/video-js.css";
@import "@/assets/scss/video-theme.scss";

.player-container {
  padding: 0;
  background: black;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  *,
  *::before,
  *::after {
    font-family: VideoJS, "Averta Cy" !important;
    font-weight: 400;
  }
  .header {
    position: fixed;
    top: 1em;
    left: 1em;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 999;
    .title {
      float: left;
    }
    .btn-close {
      float: left;
    }
    svg {
      width: 4em;
      height: 4em;
      fill: #fff;
    }
  }
  .vjs-user-inactive {
    .header {
      opacity: 0;
      transition: all 0.4s ease-in-out;
    }
  }
}
</style>
